/** Escape source labels before inserting them into ECharts' HTML tooltips. */
export function escapeHtml(value: string): string {
  return value.replace(/[&<>"']/g, (character) => `&#${character.charCodeAt(0)};`);
}
